// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DelegateGroupedTokenImageVoteTable_wrapper__2v7FT","tokenCell":"DelegateGroupedTokenImageVoteTable_tokenCell__2-yyF"};